import { SxProps, Theme } from '@mui/material';

export const PixStyles = (theme: Theme): Record<string, SxProps<Theme>> => ({
  mainContainer: {
    backgroundImage: `repeating-linear-gradient(0deg, ${theme.palette.primary.light}, ${theme.palette.primary.light} 24px, transparent 24px, transparent 34px, ${theme.palette.primary.light} 34px), repeating-linear-gradient(90deg, ${theme.palette.primary.light}, ${theme.palette.primary.light} 24px, transparent 24px, transparent 34px, ${theme.palette.primary.light} 34px), repeating-linear-gradient(180deg, ${theme.palette.primary.light}, ${theme.palette.primary.light} 24px, transparent 24px, transparent 34px, ${theme.palette.primary.light} 34px), repeating-linear-gradient(270deg, ${theme.palette.primary.light}, ${theme.palette.primary.light} 24px, transparent 24px, transparent 34px, ${theme.palette.primary.light} 34px)`,
    backgroundSize: '4px 100%, 100% 4px, 4px 100% , 100% 4px',
    backgroundPosition: '0 0, 0 0, 100% 0, 0 100%',
    backgroundRepeat: 'no-repeat',
    width: 'fit-content',
    padding: '1rem',
    marginInline: { xs: '1rem', sm: 'auto', md: '2rem' },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '1rem'
  },
  textContainer: { display: 'flex', flexDirection: 'column', gap: '0.5rem', width: '100%' },
  text: { fontWeight: '600', display: 'flex', gap: '0.4rem' },
  secondaryContainer: {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '2rem'
  },
  actionButtonContainer: { display: 'flex', flexDirection: 'column', gap: '1rem', alignItems: 'center' },
  timeChip: { color: 'white', fontSize: '1rem', fontWeight: '700', padding: '0.43rem' },
  actionButton: {
    width: '14rem',
    fontSize: '1rem',
    paddingBlock: '0.62rem',
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.contrastText
  },
  pixContainer: {
    padding: '1.5rem',
    backgroundColor: theme.customColors.purple[750],
    borderRadius: '8px',
    textAlign: 'center'
  }
});
